// extracted by mini-css-extract-plugin
export default {"box":"productDetailPage_box__vEELr"};